module.exports = __webpack_public_path__ + "img/section11.9c67129a.png";